import { fromJS } from 'immutable';

const Pages = require('./pages');

class Project {
  params: any;

  getParam(name: string) {
    const value = this.params.get(name);

    return value.toJS ? value.toJS() : value;
  }

  setParam(name: string, value: any) {
    this.params = this.params.set(name, fromJS(value));
    return this.params;
  }

  getPages() {
    return Pages;
  }

  getType() {
    return this.params.get('schemaType');
  }

  getVersion() {
    return this.params.get('schemaVersion');
  }

  init(project: any) {
    const { pages, ...params } = project;
    this.params = fromJS(params);
    Pages.setPages(pages);
  }

  toData() {
    return {
      ...this.params.toJS(),
      pages: this.getPages().toData(),
    };
  }
}

export default new Project();



// WEBPACK FOOTER //
// ./lib/engine/core/project.ts